import { createSliceDefinitions } from 'store/helpers/createSliceDefinitions';

export const UNDERWRITING_QUESTIONS_QUERY_KEY = 'underwritingQuestions';
export const SUBMISSION_PRICE_QUERY_KEY = 'submissionPrice';
export const EXCLUDE_WC_RULE_RESULT_QUERY_KEY = 'excludeWcRuleResult';

export const { actions: SUBMISSION_MUTATION_KEYS, name: SUBMISSION_QUERY_KEY } =
  createSliceDefinitions('submission', {
    UPDATE_UW_QUESTIONS: 'updateUnderwritingQuestions',
    UPDATE_POLICY_DATA: 'updatePolicyData',
    ADD_EXPOSURE: 'addExposure',
    UPDATE_EXPOSURE: 'updateExposure',
    DELETE_EXPOSURE: 'deleteExposure',
    ADD_GROUP_FIELD: 'addGroupField',
    BULK_ADD_GROUP_FIELD: 'bulkAddGroupField',
    UPDATE_GROUP_FIELD: 'updateGroupField',
    BULK_UPDATE_GROUP_FIELD: 'bulksUpdateGroupField',
    BULK_UPDATE_EXPOSURE: 'bulksUpdateExposure',
    BULK_DELETE_GROUP_FIELD: 'bulkDeleteGroupField',
    DELETE_GROUP_FIELD: 'deleteGroupField',
    CREATE_QUOTE_FROM_SUBMISSION: 'createQuoteFromSubmission',
    CREATE_SUBMISSION: 'createSubmission',
    UPDATE_SUBMISSION: 'updateSubmission',
    UPDATE_PAYMENT_PLAN: 'updatePaymentPlan',
    UPDATE_PAPERLESS_OPT_IN: 'updatePaperlessOptIn',
  });
